import { render, staticRenderFns } from "./Funil.vue?vue&type=template&id=4b8d4728&"
import script from "./Funil.vue?vue&type=script&lang=js&"
export * from "./Funil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports